import { dateProvider } from '@utils';

import { Item, ItemText, Wrapper } from './ExamGroupInfo.styles';

import { useExamGroupsById } from '@/store';

type ExamGroupInfoProps = {
  examGroupsIds: string[];
};

export const ExamGroupInfo: React.FC<ExamGroupInfoProps> = ({ examGroupsIds }) => {
  const { examGroups } = useExamGroupsById(examGroupsIds);
  if (!examGroups) return null;
  return (
    <Wrapper>
      {examGroups?.map(examGroup => (
        <Item key={examGroup._id}>
          <ItemText>{examGroup.name}</ItemText>
          {examGroup?.examDate && (
            <ItemText> - {dateProvider.format(examGroup?.examDate, 'dd/MM/yyyy')}</ItemText>
          )}
        </Item>
      ))}
    </Wrapper>
  );
};
